module.exports = __webpack_public_path__ + "img/7.94720fde.png";